export default __webpack_public_path__ + "static/font-7ae18defcc1c82dd2d930f7c81a81312.woff2";